import "./App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import ContactPage from "@frontend/app/contact/ContactPage.tsx";
import RootLayout from "@frontend/app/layout/RootLayout";
import LandingPage from "@frontend/app/landing/LandingPage";
import ProjectsPage from "@frontend/app/projects/ProjectsPage";
import ProtectedRoute from "@frontend/app/routing/ProtectedRoute.tsx";
import JobCaterEditorParent from "@frontend/app/catering/editing/JobCaterEditorParent.tsx";
import JobCaterDisplay from "@frontend/app/catering/display/JobCaterDisplay.tsx";
import LoginCallback from "@frontend/app/auth/LoginCallback.tsx";
import ErrorPage from "@frontend/app/layout/ErrorPage.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { META } from "@frontend/config/meta.config.ts";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />} errorElement={<ErrorPage />}>
      <Route index element={<LandingPage />} handle={{ meta: META.home }} />
      <Route path="projects" element={<ProjectsPage />} handle={{ meta: META.projects }} />
      <Route path="contact" element={<ContactPage />} handle={{ meta: META.contact }} />
      <Route path="login" element={<LoginCallback />} />
      <Route path="cater">
        <Route
          path="edit"
          element={
            <ProtectedRoute>
              <JobCaterEditorParent />
            </ProtectedRoute>
          }
        />
        <Route path=":postID" element={<JobCaterDisplay />} handle={{ meta: META.cater }} />
      </Route>
    </Route>
  )
);

const queryClient = new QueryClient();

const App = () => (
  <Sentry.ErrorBoundary fallback={({ error }) => <div>Something went wrong: {error.message}</div>} showDialog>
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </HelmetProvider>
  </Sentry.ErrorBoundary>
);

export default App;
